import { render, staticRenderFns } from "./PayslipDetails.vue?vue&type=template&id=15f4ddfd"
import script from "./PayslipDetails.vue?vue&type=script&lang=js"
export * from "./PayslipDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports